module.exports = __webpack_public_path__ + "img/personalcard.db59e7a0.svg";